export function generateTitles(elementList) {
    const list = []
    if (elementList) {
        elementList.map((e) => {
            if (e.location?._text !== undefined && e.location?._text !== "") {
                const title = e.title._text + ", " + e.year._text + ", " + e.location._text
                list.push({
                    label: title
                })
            } else {
                const title = e.title._text + ", " + e.year._text
                list.push({
                    label: title
                })
            }
        })
        return list
    }
    return list
}

export function convertBlobToBase64(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
            const base64data = reader.result.split(',')[1];
            resolve(base64data);
        };
        reader.onerror = (error) => {
            reject(error);
        };
    });
}